module.exports = __webpack_public_path__ + "img/s1-2.7caa646a.jpg";